import { HttpRequestData, httpUtil, PaginationResponse } from '@esg/framework';
import { getEnv, PaginationRequest } from '@esg/shared';

interface GetBranchesRequest extends HttpRequestData {
    readonly query: PaginationRequest & {
        startTime?: string;
        endTime?: string;
        organizationId?: string;
    };
}

export interface BranchItem {
    id: string;
    name: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
    phoneNumber: string | null;
    logo: string | null;
    timezone: string;
    languages: string | null;
    country: string;
    countryCode: string | null;
    phoneCountryId: number | null;
    currency: string | null;
    tax: any | null;
    dateTimeFormat: string | null;
    category: string | null;
    organizationId: string;
    organizationName: string;
}

export const getBranches = httpUtil.createHttpRequestMeta<
    GetBranchesRequest,
    PaginationResponse<BranchItem>
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/branches',
    method: 'GET',
    authentication: 'bearer',
});